<!--
 * @Author: dengyong simon.deng@wetax.com.cn
 * @Date: 2022-06-20 14:08:23
 * @LastEditors: yangyi
 * @LastEditTime: 2022-11-18 11:53:01
 * @FilePath: \tiangong2\src\views\sysmana\member\components\cooperationLog.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->

<template>
  <div class="log">
    <el-table :data="tableData" class="table" border v-loading="loading" style="width: 100%">
      <el-table-column label="日期">
        <template slot-scope="{ row }">
          {{ row.loginTime | datetimeToSec }}
        </template>
      </el-table-column>
      <el-table-column label="IP">
        <template slot-scope="{ row }">
          {{ row.addr }}
        </template>
      </el-table-column>
      <el-table-column label="设备">
        <!-- <template slot-scope="{row}">
           </template> -->
      </el-table-column>
      <el-table-column label="登录系统">
        <!-- <template slot-scope="{row}">
           </template> -->
      </el-table-column>
    </el-table>
    <Page
      v-if="tableData.length > 0"
      show-total
      show-sizer
      show-elevator
      :total="total"
      :current.sync="pageIndex"
      :page-size="pageSize"
      @on-change="changePageIndex"
      @on-page-size-change="changePageSize"
      class="c-table-page"
      size="small"
    />
  </div>
</template>
</template>
<script>
import { queryLogApi } from '@/api/sysmana.model'
export default {
  name: 'cooperationLog',
  props: ['cooperationData'],

  data() {
    return {
      loading: false,
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      tableData: []
    }
  },
  watch: {
    cooperationData() {
      this.getLog()
    }
  },
  created() {
    this.getLog()
  },
  methods: {
    getLog() {
      this.loading = true
      queryLogApi({
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        userId: this.cooperationData.userId
      }).then((data) => {
        if (data) {
          const { list, page_info } = data
          this.loading = false
          this.tableData = list
          this.total = page_info.total_number
        }
      })
    },
    changePageIndex(index) {
      this.pageIndex = index
      this.getLog()
    },
    changePageSize(size) {
      this.pageSize = size
      this.getLog()
    }
  }
}
</script>
<style lang="scss" scoped>
.table {
  max-height: 500px;
  overflow: auto;
}
.c-table-page {
  margin: 10px 0 !important;
  padding: 0 8px;
  text-align: right;
}
</style>
